"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _values2 = _interopRequireDefault(require("lodash-es/values"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _tableColumn = _interopRequireDefault(require("./_table-column"));

var _resizeGrip = _interopRequireDefault(require("./_resize-grip"));

var _pixelcalculations = require("../../_utils/pixelcalculations");

var _components = require("./_components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var COLUMN_NAME = 'secondary-th';

var TableHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableHeader, _React$Component);

  function TableHeader(props) {
    var _this;

    _classCallCheck(this, TableHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableHeader).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (!_this.props.hidden) {
        (0, _values2["default"])(_this._headersAndGrips).forEach(function (_ref) {
          var th = _ref.th,
              grip = _ref.grip,
              field = _ref.field;
          grip.addEventListener('mousedown', function (e) {
            return _this._handleMouseDown(e, th, field);
          });
          grip.addEventListener('mouseover', function (e) {
            return _this._hanldeMouseOver(field);
          });
          grip.addEventListener('mouseout', function (e) {
            return _this._hanldeMouseOut(field);
          });
        });
        document.addEventListener('mousemove', _this._handleMouseMove);
        document.addEventListener('mouseup', _this._handleMouseUp);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (!_this.props.hidden) {
        (0, _values2["default"])(_this._headersAndGrips).forEach(function (_ref2) {
          var th = _ref2.th,
              grip = _ref2.grip,
              field = _ref2.field;
          grip.removeEventListener('mousedown', function (e) {
            return _this._handleMouseDown(e, th, field);
          });
          grip.removeEventListener('mouseover', function (e) {
            return _this._hanldeMouseOver(field);
          });
          grip.removeEventListener('mouseout', function (e) {
            return _this._hanldeMouseOut(field);
          });
        });
        document.removeEventListener('mousemove', _this._handleMouseMove);
        document.removeEventListener('mouseup', _this._handleMouseUp);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_addRefs", function (index, type, elem, field) {
      _this._headersAndGrips[index] = _objectSpread({}, _this._headersAndGrips[index], _defineProperty({
        field: field
      }, type === 'th' ? 'th' : 'grip', elem));
    });

    _defineProperty(_assertThisInitialized(_this), "_hanldeMouseOver", function (field) {
      return _this.props.onResizeHover(field, true);
    });

    _defineProperty(_assertThisInitialized(_this), "_hanldeMouseOut", function (field) {
      return _this.props.onResizeHover(field, false);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleMouseDown", function (e, th, field) {
      _this._field = field;
      _this._thElm = th;
      _this._startOffset = th.offsetWidth - e.pageX;

      _this.props.onResizeStart(_this._field);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleMouseMove", function (e) {
      if (_this._field && _this._thElm) {
        var width = _this._startOffset + e.pageX;
        if (width < _this.minWidth) width = _this.minWidth;else if (width > _this.maxWidth) width = _this.maxWidth;
        _this._thElm.style.width = width + 'px';

        if (_this.props.container && _this.props.fixedHeader) {
          var index = _this._thElm.dataset.index; //* finding the current column of the second table

          _this.props.container.querySelector(".".concat(COLUMN_NAME, "-").concat(index)).style.width = width + 'px';
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleMouseUp", function (e) {
      if (_this._field && _this._thElm) {
        _this.props.onResizeStop(_this._field, _this._thElm.style.width);
      }

      _this._field = undefined;
      _this._thElm = undefined;
    });

    _this._headersAndGrips = {};
    _this._field = undefined;
    _this._thElm = undefined;
    _this._startOffset = null;
    _this.minWidth = (0, _pixelcalculations.parse)(props.minWidth).value;
    _this.maxWidth = 560;
    return _this;
  }

  _createClass(TableHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          version = _this$props.version,
          headerBorder = _this$props.headerBorder,
          headerHover = _this$props.headerHover,
          headerSeparator = _this$props.headerSeparator,
          resizeGripHeight = _this$props.resizeGripHeight,
          hidden = _this$props.hidden;
      var cells = this.props.columns.map(function (column, index) {
        var sortIndicator;
        var align = column.align || 'left';

        if (column.sort) {
          var order = column.sort || 'asc';
          var icon = order === 'asc' ? '↑' : '↓';
          sortIndicator = _react["default"].createElement(TableHeader.SortIndicator, null, icon);
        }

        var styleWidth = (0, _pixelcalculations.widthInRange)(column.width, _this2.minWidth);
        return _react["default"].createElement(TableHeader.Cell, {
          key: "row-header-".concat(index),
          innerRef: function innerRef(el) {
            return _this2._addRefs(index, 'th', el, column.field);
          },
          column: column,
          style: {
            'width': styleWidth,
            'textAlign': align
          },
          version: version,
          headerBorder: headerBorder,
          headerHover: headerHover,
          "data-index": index,
          className: hidden ? "".concat(COLUMN_NAME, "-").concat(index) : null
        }, _react["default"].createElement(TableHeader.Text, {
          column: column,
          onClick: function onClick() {
            return _this2.props.onSort(column);
          }
        }, column.title, sortIndicator), _react["default"].createElement(_resizeGrip["default"], {
          innerRef: function innerRef(el) {
            return _this2._addRefs(index, 'grip', el);
          },
          version: version,
          separator: headerSeparator,
          height: resizeGripHeight
        }));
      });
      return _react["default"].createElement(TableHeader.Element, null, _react["default"].createElement(TableHeader.Row, null, cells));
    }
  }]);

  return TableHeader;
}(_react["default"].Component);

TableHeader.Row = _components.TableHeaderRow;
TableHeader.Element = _components.TableHeaderElement;
TableHeader.Cell = _components.TableHeaderCell;
TableHeader.Text = _components.TableHeaderText;
TableHeader.SortIndicator = _components.TableHeaderSortIndicator;
TableHeader.propTypes = {
  columns: _propTypes["default"].arrayOf(_tableColumn["default"]),
  onSort: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  applyWidth: _propTypes["default"].func
};
TableHeader.defaultProps = {
  onSort: function onSort(column) {
    return function (event) {
      return null;
    };
  },
  applyWidth: _noop2["default"],
  clickable: false
};
var _default = TableHeader;
exports["default"] = _default;